import { render, staticRenderFns } from "./BaseSwiper.vue?vue&type=template&id=7999cff4&"
import script from "./BaseSwiper.vue?vue&type=script&lang=js&"
export * from "./BaseSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports